// announcement bar

window.addEventListener("resize", function () {
  var slider = document.querySelector(".announcement__col--left");
  if (window.innerWidth < 769) {
    // Enable slider
    slider.classList.add("announcement__slider");
  } else {
    // Disable slider
    slider.classList.remove("announcement__slider");
  }
});

// Check on page load
window.dispatchEvent(new Event("resize"));


/*document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("search-bar-input");
  const navMenu = document.querySelector(".fullsearch-container");

  searchInput.addEventListener("focus", function () {
    navMenu.classList.remove("hidden");
    navMenu.classList.add("visible");
  });

  searchInput.addEventListener("blur", function () {
    navMenu.classList.remove("visible");
    navMenu.classList.add("hidden");
  });
});*/
